import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * The search-parameters panel beside the search box: a press anywhere but the
 * panel or its button closes it, and closing it folds its match-type list.
 */
export function useMatchOptionsPanel() {
  const [open, setOpen] = useState(false)
  const [matchTypeOpen, setMatchTypeOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const panelRef = useRef<HTMLDivElement>(null)

  /** Whether a press landed on the panel or its button. */
  const isOwnTarget = useCallback(
    (target: Node) =>
      Boolean(panelRef.current?.contains(target) || buttonRef.current?.contains(target)),
    []
  )

  useEffect(() => {
    if (!open) return
    const onPointerDown = (event: PointerEvent) => {
      if (!isOwnTarget(event.target as Node)) setOpen(false)
    }
    document.addEventListener('pointerdown', onPointerDown)
    return () => document.removeEventListener('pointerdown', onPointerDown)
  }, [open, isOwnTarget])

  useEffect(() => {
    if (!open) setMatchTypeOpen(false)
  }, [open])

  return { open, setOpen, matchTypeOpen, setMatchTypeOpen, buttonRef, panelRef, isOwnTarget }
}
